var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAngleRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow-angle-right-grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.0138514,2.45666036 C20.0891943,2.45666036 20.1632399,2.46221518 20.2356009,2.47293763 C20.2685033,2.47791783 20.3019102,2.48402727 20.3351194,2.49127512 C20.4627731,2.51902252 20.5841257,2.5630381 20.6971603,2.62098065 C20.7156776,2.63036522 20.7338523,2.64015136 20.7518616,2.65033963 C20.7759875,2.66412899 20.7998276,2.67851897 20.8232229,2.69354117 C20.8401018,2.70423229 20.8565617,2.71527242 20.8728462,2.72667381 C20.8958129,2.7428936 20.9180916,2.75942753 20.9398843,2.77655209 C20.9550089,2.78833943 20.9704457,2.80097358 20.9856846,2.81396205 C21.0078994,2.83293736 21.0293849,2.85232903 21.0502933,2.87231939 C21.0575643,2.87927491 21.0643779,2.88591994 21.0711435,2.89264278 L21.0972165,2.91919877 C21.1149654,2.93772801 21.1322436,2.95671174 21.149032,2.97613074 L21.0711435,2.89264278 C21.1142452,2.93547208 21.1542018,2.98026941 21.1910122,3.02674752 C21.2055489,3.045251 21.2200626,3.06451579 21.2341148,3.08413351 C21.2503693,3.10661602 21.265523,3.12904481 21.2800045,3.15177925 C21.2911324,3.16949126 21.3022253,3.18774028 21.3129344,3.20623923 C21.3239172,3.22498168 21.3342476,3.24377658 21.3441452,3.26273909 C21.4525632,3.47044972 21.5138514,3.70639773 21.5138514,3.95666036 L21.5138514,20.0295591 C21.5138514,20.8579862 20.8422785,21.5295591 20.0138514,21.5295591 C19.1854242,21.5295591 18.5138514,20.8579862 18.5138514,20.0295591 L18.5135468,7.59366032 L5.10656446,21.0868512 C4.52263816,21.6744919 3.57289547,21.677503 2.98525478,21.0935767 C2.3976141,20.5096504 2.39460299,19.5599077 2.9785293,18.972267 L16.4075468,5.45666032 L4.04254688,5.45666036 C3.26285076,5.45666036 2.6220982,4.86177228 2.54941346,4.10112037 L2.54254688,3.95666036 C2.54254688,3.12823324 3.21411976,2.45666036 4.04254688,2.45666036 L20.0138514,2.45666036 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-angle-right-grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/light-grey",
    mask: "url(#mask-2)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAngleRightGrey);
export default __webpack_public_path__ + "static/media/arrow-angle-right-grey.e003230fcc086ff140d236709d2140a8.svg";
export { ForwardRef as ReactComponent };